import * as React from 'react';
import { Secondary } from 'rcd-cpp-ui/ui/button';
import { useSelector } from '../../../utils/useSelector';
import { useActions } from './copyPreviousButtonActions';
import { SchemaField } from '../../../types';
import { getSchemaForm, getSchema } from '../../../utils';
import { NodeType } from '../../../enums/NodeType';
import { TriggerLocation } from '../../../enums/TriggerLocation';
import { WorkspacePrefix } from '../../../enums/WorkspacePrefix';

type Props = {
  updateFields: (fields: { field: SchemaField; value: any }[]) => any;
};

const FieldsToCopy: { [x: string]: string[] } = {
  content: [
    'function',
    'role',
    'primaryQuestion',
    'author',
    'researchModel',
    'contentType',
    'contentSubtype',
    'useCase',
    'market'
  ],
  globalSubmission: [
    'function',
    'role',
    'topicCategory',
    'taxonomyTag',
    'rolePriority',
    'priorityJourneyStep',
    'additionalTopicCategory',
    'additionalTaxonomyTag',
    'confSessionType',
    'peerReviewer'
  ]
};

export const CopyFromPreviousButton = ({ updateFields }: Props) => {
  const itemType = useSelector(s => {
    const w = s.planning?.selectedWorkspace;
    if (w?.props?.prefix == WorkspacePrefix.Markets) {
      return null;
    }
    const data = s.form?.data;
    if (!data?.props) return null;
    if (
      ![
        TriggerLocation.BOARD_GROUP,
        TriggerLocation.NAV,
        TriggerLocation.VIEW
      ].includes(data?.triggerLocation)
    ) {
      return null;
    }
    const itemType = data.props?.itemType;
    if (!itemType || !Object.keys(FieldsToCopy).includes(itemType)) {
      return null;
    }
    return itemType;
  });
  const fieldsToCopy = FieldsToCopy[itemType];
  const lastCreatedItem = useSelector(s => {
    if (!itemType) return null;
    if (!s.planning?.lastCreatedItems) return null;
    return s.planning.lastCreatedItems[itemType];
  });
  const schemaForm = useSelector(s => {
    if (!itemType) return null;
    const itemSchema = getSchema(
      s.planning?.selectedWorkspace?.schemas,
      NodeType.Item
    );
    if (!itemSchema) return null;
    return getSchemaForm(itemSchema, itemType);
  });

  const { loadLastCreatedItem } = useActions();

  React.useEffect(() => {
    if (itemType) loadLastCreatedItem(itemType);
  }, [itemType]);

  if (!lastCreatedItem?.props) return null;
  if (!fieldsToCopy?.length) return null;
  if (!schemaForm?.props?.fields?.length) return null;

  return (
    <Secondary
      label="Add Last Document's Data"
      onClick={() => {
        updateFields(
          schemaForm.props.fields.reduce((vals, field) => {
            if (fieldsToCopy.includes(field.field)) {
              const value = lastCreatedItem.props[field.field];
              if (value !== null && value !== undefined) {
                if (Array.isArray(value) && value.length == 0) return vals;
                vals.push({ field, value });
              }
            }
            return vals;
          }, [])
        );
      }}
    />
  );
};
